import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-hidden"
};
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = {
  class: "flex items-center justify-between gap-3 border-b border-slate-200 px-6 py-4"
};
const _hoisted_4 = {
  class: "flex min-w-0 items-center gap-2.5"
};
const _hoisted_5 = {
  class: "truncate text-lg font-semibold text-slate-900"
};
const _hoisted_6 = {
  class: "min-h-0 flex-1 overflow-y-auto p-6"
};
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center py-16"
};
const _hoisted_8 = {
  class: "flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-slate-600"
};
const _hoisted_9 = {
  class: "inline-flex items-center gap-1.5"
};
const _hoisted_10 = {
  key: 0,
  class: "inline-flex items-center gap-1.5"
};
const _hoisted_11 = ["href"];
const _hoisted_12 = {
  class: "inline-flex items-center gap-1.5"
};
const _hoisted_13 = {
  key: 2,
  class: "inline-flex items-center gap-1.5"
};
const _hoisted_14 = {
  class: "mt-6 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2"
};
const _hoisted_15 = {
  class: "mt-1 text-sm text-slate-800"
};
const _hoisted_16 = {
  class: "mt-1 text-sm text-slate-800"
};
const _hoisted_17 = {
  class: "sm:col-span-2"
};
const _hoisted_18 = {
  class: "sm:col-span-2"
};
const _hoisted_19 = {
  class: "mt-1"
};
const _hoisted_20 = {
  key: 0,
  class: "flex items-center gap-3"
};
const _hoisted_21 = {
  class: "h-1.5 flex-1 rounded-full bg-slate-100"
};
const _hoisted_22 = {
  class: "text-sm tabular-nums text-slate-600"
};
const _hoisted_23 = {
  key: 1,
  class: "text-sm text-slate-400"
};
const _hoisted_24 = {
  key: 0,
  class: "sm:col-span-2"
};
const _hoisted_25 = {
  class: "mt-1 whitespace-pre-wrap text-sm text-slate-800"
};
const _hoisted_26 = {
  class: "sticky top-0 z-10 mt-6 bg-white pb-4"
};
const _hoisted_27 = {
  class: "list-page-segmented"
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  key: 2,
  class: "empty-state"
};
const _hoisted_30 = {
  key: 0,
  class: "flex flex-wrap items-center justify-end gap-3 border-t border-slate-200 px-6 py-4"
};
import { ref, computed, watch, toRef } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useUserStore } from '@/stores/user';
import { meetingApi } from '@/api/meeting';
import { formatDateTime } from '@/utils/dateFormat';
import { useModalA11y } from '@/composables/useModalA11y';
import ActionItemPanel from './ActionItemPanel.vue';
import MaterialPanel from './MaterialPanel.vue';
import MinutesPanel from './MinutesPanel.vue';
import MeetingAttendeeSection from './MeetingAttendeeSection.vue';
export default {
  __name: 'MeetingDetailDrawer',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    meetingId: {
      type: [Number, String],
      default: null
    }
  },
  emits: ['update:modelValue', 'edit', 'refresh'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const panelRef = ref(null);
    useModalA11y(toRef(props, 'modelValue'), panelRef, () => emit('update:modelValue', false));

    // 详情数据
    const detail = ref(null); // MeetingDetailDTO
    const detailLoading = ref(false);
    const activePanel = ref('actions'); // actions / materials / minutes
    const actionPanelRef = ref(null);

    // 状态/类型徽章颜色映射（文案直接使用后端 desc 字段；参会人相关徽章已收口到 MeetingAttendeeSection）
    const MEETING_STATUS_CLASS = {
      PLANNED: 'is-info',
      ENDED: 'is-neutral',
      CANCELLED: 'is-danger'
    };
    const MEETING_TYPE_CLASS = {
      INTERNAL: 'is-teal',
      CUSTOMER: 'is-indigo'
    };
    const MEETING_MODE_CLASS = {
      OFFLINE: 'is-neutral',
      ONLINE: 'is-cyan',
      HYBRID: 'is-indigo'
    };
    const PANEL_TABS = [{
      key: 'actions',
      label: '决策项'
    }, {
      key: 'materials',
      label: '物料'
    }, {
      key: 'minutes',
      label: '纪要'
    }];
    const drawerTitle = computed(() => detail.value?.meeting?.title || '会议详情');
    const isPlanned = computed(() => detail.value?.meeting?.status === 'PLANNED');

    // 归属判断：会议管理操作仅组织者/主持人可见（后端归属授权强制，此处只做 UI 显隐）
    const userStore = useUserStore();
    const currentUserId = computed(() => userStore.userInfo?.userId);
    const isManager = computed(() => {
      const meeting = detail.value?.meeting;
      if (!meeting || currentUserId.value == null) return false;
      return Number(meeting.organizerId) === Number(currentUserId.value) || Number(meeting.hostId) === Number(currentUserId.value);
    });
    // 传给各面板的写操作开关：待召开 + 管理者（参会人区块单独传 isManager，自行按状态组合）
    const canManage = computed(() => isPlanned.value && isManager.value);

    // 决策项负责人候选：会议相关人员（参会人 + 组织者/主持人，按 id 去重）
    const assigneeCandidates = computed(() => {
      const list = [];
      const seen = new Set();
      const push = (id, name) => {
        if (id == null || seen.has(Number(id))) return;
        seen.add(Number(id));
        list.push({
          id,
          name: name || `用户#${id}`
        });
      };
      (detail.value?.attendees || []).forEach(a => push(a.userId, a.userName));
      const meeting = detail.value?.meeting;
      if (meeting) {
        push(meeting.organizerId, meeting.organizerName);
        push(meeting.hostId, meeting.hostName);
      }
      return list;
    });

    // 查看 Tab 不再按权限过滤（进得了会议详情即可看，后端 isVisible 兜底）
    const visibleTabs = computed(() => PANEL_TABS);
    // 打开时默认回到第一个 Tab
    const fallbackPanel = () => visibleTabs.value[0]?.key || 'actions';

    // 决策项完成百分比
    const actionProgressPercent = computed(() => {
      const total = Number(detail.value?.actionTotal) || 0;
      if (total === 0) return 0;
      const done = Number(detail.value?.actionDone) || 0;
      return Math.min(100, Math.round(done / total * 100));
    });
    const fetchDetail = async () => {
      if (!props.meetingId) return;
      detailLoading.value = true;
      try {
        detail.value = await meetingApi.getMeetingDetail(props.meetingId);
      } catch (error) {
        // 拦截器已提示
        console.error('获取会议详情失败:', error);
      } finally {
        detailLoading.value = false;
      }
    };
    watch(() => [props.modelValue, props.meetingId], ([visible]) => {
      if (visible && props.meetingId) {
        // 打开/切换会议时回到默认 Tab
        activePanel.value = fallbackPanel();
        fetchDetail();
      }
    });

    // 取消/结束会议后刷新详情与各面板
    const reloadPanels = () => {
      fetchDetail();
      actionPanelRef.value?.fetchList?.();
    };

    // 编辑会议（父组件 handleEdit 会再拉一次详情取 attendeeUserIds，重复请求属已知无害行为）
    const handleEdit = () => {
      if (!detail.value?.meeting) return;
      emit('edit', detail.value.meeting);
    };

    // 取消会议
    const handleCancel = async () => {
      try {
        await ElMessageBox.confirm(`确定要取消会议「${detail.value?.meeting?.title}」吗？`, '提示', {
          type: 'warning'
        });
        await meetingApi.cancelMeeting(props.meetingId);
        ElMessage.success('会议已取消');
        reloadPanels();
        emit('refresh');
      } catch (error) {
        if (error !== 'cancel') {
          console.error('取消会议失败:', error);
        }
      }
    };

    // 结束会议
    const handleEnd = async () => {
      try {
        await ElMessageBox.confirm(`确定要结束会议「${detail.value?.meeting?.title}」吗？`, '提示', {
          type: 'warning'
        });
        await meetingApi.endMeeting(props.meetingId);
        ElMessage.success('会议已结束');
        reloadPanels();
        emit('refresh');
      } catch (error) {
        if (error !== 'cancel') {
          console.error('结束会议失败:', error);
        }
      }
    };

    // 暴露给父组件：表单保存后抽屉仍打开时同步刷新详情
    __expose({
      fetchDetail
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [__props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "absolute inset-0 bg-slate-900/40",
        onClick: _cache[0] || (_cache[0] = $event => emit('update:modelValue', false))
      }), _createElementVNode("section", {
        ref_key: "panelRef",
        ref: panelRef,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": drawerTitle.value,
        tabindex: "-1",
        class: "absolute right-0 top-0 flex h-full w-full max-w-4xl flex-col bg-white shadow-xl"
      }, [_createElementVNode("header", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h3", _hoisted_5, _toDisplayString(drawerTitle.value), 1), detail.value && detail.value.meeting ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(['status-badge shrink-0', MEETING_STATUS_CLASS[detail.value.meeting.status] || 'is-neutral'])
      }, _toDisplayString(detail.value.meeting.statusDesc || detail.value.meeting.status), 3)) : _createCommentVNode("", true)]), _createElementVNode("button", {
        type: "button",
        class: "rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
        onClick: _cache[1] || (_cache[1] = $event => emit('update:modelValue', false))
      }, [...(_cache[2] || (_cache[2] = [_createElementVNode("svg", {
        class: "h-5 w-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])]), _createElementVNode("main", _hoisted_6, [detailLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
        class: "app-spinner",
        role: "status",
        "aria-label": "加载中"
      }, null, -1)]))])) : detail.value && detail.value.meeting ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, [_cache[4] || (_cache[4] = _createElementVNode("svg", {
        class: "h-4 w-4 shrink-0 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      })], -1)), _createTextVNode(" " + _toDisplayString(_unref(formatDateTime)(detail.value.meeting.startTime)) + " ~ " + _toDisplayString(_unref(formatDateTime)(detail.value.meeting.endTime)), 1)]), detail.value.meeting.location ? (_openBlock(), _createElementBlock("span", _hoisted_10, [_cache[5] || (_cache[5] = _createElementVNode("svg", {
        class: "h-4 w-4 shrink-0 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
      }), _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
      })], -1)), _createTextVNode(" " + _toDisplayString(detail.value.meeting.location), 1)])) : _createCommentVNode("", true), detail.value.meeting.onlineLink ? (_openBlock(), _createElementBlock("a", {
        key: 1,
        href: detail.value.meeting.onlineLink,
        target: "_blank",
        rel: "noopener noreferrer",
        class: "inline-flex items-center gap-1.5 text-primary-600 hover:underline"
      }, [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
        class: "h-4 w-4 shrink-0",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
      })], -1), _createTextVNode(" 线上会议链接 ", -1)]))], 8, _hoisted_11)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_12, [_cache[7] || (_cache[7] = _createElementVNode("svg", {
        class: "h-4 w-4 shrink-0 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
      })], -1)), _createTextVNode(" 组织者 " + _toDisplayString(detail.value.meeting.organizerName || '-'), 1)]), detail.value.meeting.hostName && detail.value.meeting.hostName !== detail.value.meeting.organizerName ? (_openBlock(), _createElementBlock("span", _hoisted_13, " 主持人 " + _toDisplayString(detail.value.meeting.hostName), 1)) : _createCommentVNode("", true)]), _createElementVNode("dl", _hoisted_14, [_createElementVNode("div", null, [_cache[8] || (_cache[8] = _createElementVNode("dt", {
        class: "text-xs font-medium text-slate-500"
      }, "会议类型", -1)), _createElementVNode("dd", _hoisted_15, [_createElementVNode("span", {
        class: _normalizeClass(['status-badge', MEETING_TYPE_CLASS[detail.value.meeting.meetingType] || 'is-neutral'])
      }, _toDisplayString(detail.value.meeting.meetingTypeDesc || detail.value.meeting.meetingType), 3)])]), _createElementVNode("div", null, [_cache[9] || (_cache[9] = _createElementVNode("dt", {
        class: "text-xs font-medium text-slate-500"
      }, "会议方式", -1)), _createElementVNode("dd", _hoisted_16, [_createElementVNode("span", {
        class: _normalizeClass(['status-badge', MEETING_MODE_CLASS[detail.value.meeting.meetingMode] || 'is-neutral'])
      }, _toDisplayString(detail.value.meeting.meetingModeDesc || detail.value.meeting.meetingMode || '-'), 3)])]), _createElementVNode("div", _hoisted_17, [_createVNode(MeetingAttendeeSection, {
        "meeting-id": props.meetingId,
        attendees: detail.value.attendees,
        "meeting-status": detail.value.meeting.status,
        "can-manage": isManager.value,
        onChanged: fetchDetail
      }, null, 8, ["meeting-id", "attendees", "meeting-status", "can-manage"])]), _createElementVNode("div", _hoisted_18, [_cache[10] || (_cache[10] = _createElementVNode("dt", {
        class: "text-xs font-medium text-slate-500"
      }, "决策项进度", -1)), _createElementVNode("dd", _hoisted_19, [Number(detail.value.actionTotal) > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
        class: "h-1.5 rounded-full bg-primary-600 transition-all",
        style: _normalizeStyle({
          width: actionProgressPercent.value + '%'
        })
      }, null, 4)]), _createElementVNode("span", _hoisted_22, _toDisplayString(detail.value.actionDone || 0) + "/" + _toDisplayString(detail.value.actionTotal), 1)])) : (_openBlock(), _createElementBlock("p", _hoisted_23, "暂无决策项"))])]), detail.value.meeting.remark ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_cache[11] || (_cache[11] = _createElementVNode("dt", {
        class: "text-xs font-medium text-slate-500"
      }, "备注", -1)), _createElementVNode("dd", _hoisted_25, _toDisplayString(detail.value.meeting.remark), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleTabs.value, tab => {
        return _openBlock(), _createElementBlock("button", {
          key: tab.key,
          type: "button",
          class: _normalizeClass(['list-page-segmented-item', {
            'is-active': activePanel.value === tab.key
          }]),
          onClick: $event => activePanel.value = tab.key
        }, _toDisplayString(tab.label), 11, _hoisted_28);
      }), 128))])]), _createElementVNode("div", null, [activePanel.value === 'actions' ? (_openBlock(), _createBlock(ActionItemPanel, {
        key: 0,
        ref_key: "actionPanelRef",
        ref: actionPanelRef,
        "meeting-id": props.meetingId,
        readonly: !isPlanned.value,
        "can-manage": canManage.value,
        "is-manager": isManager.value,
        candidates: assigneeCandidates.value,
        onChanged: fetchDetail
      }, null, 8, ["meeting-id", "readonly", "can-manage", "is-manager", "candidates"])) : _createCommentVNode("", true), activePanel.value === 'materials' ? (_openBlock(), _createBlock(MaterialPanel, {
        key: 1,
        "meeting-id": props.meetingId,
        readonly: !isPlanned.value,
        "can-manage": canManage.value
      }, null, 8, ["meeting-id", "readonly", "can-manage"])) : _createCommentVNode("", true), activePanel.value === 'minutes' ? (_openBlock(), _createBlock(MinutesPanel, {
        key: 2,
        "meeting-id": props.meetingId,
        readonly: !isPlanned.value,
        "can-manage": canManage.value,
        onChanged: fetchDetail
      }, null, 8, ["meeting-id", "readonly", "can-manage"])) : _createCommentVNode("", true)])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_29, [...(_cache[12] || (_cache[12] = [_createElementVNode("div", {
        class: "empty-state-icon"
      }, [_createElementVNode("svg", {
        class: "h-7 w-7",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      })])], -1), _createElementVNode("p", {
        class: "empty-state-title"
      }, "未获取到会议详情", -1)]))]))]), isPlanned.value && isManager.value ? (_openBlock(), _createElementBlock("footer", _hoisted_30, [_createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        onClick: handleEdit
      }, " 编辑 "), _createElementVNode("button", {
        type: "button",
        class: "btn-danger-secondary",
        onClick: handleCancel
      }, " 取消会议 "), _createElementVNode("button", {
        type: "button",
        class: "btn-primary",
        onClick: handleEnd
      }, " 结束会议 ")])) : _createCommentVNode("", true)], 8, _hoisted_2)])) : _createCommentVNode("", true)]);
    };
  }
};